import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { fetch, handleErrors } from '../../../api';
import api from '../../../api/endpoints';

function* getPerformanceSnapshot({ payload: { signal, onSuccess } }) {

  try {
    const { data } = yield call(fetch, {
      api: api.analytics.links,
      data: {
        include_comparison: true,
        page: 0,
        since: 'now-7d/d',
        until: 'now+1d/d'
      },
      signal
    });

    const preparedData = {
      summary: data.summary,
      comparison: data.comparison
    };

    onSuccess && onSuccess(data);

    yield put(actions.getPerformanceSnapshotDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getPerformanceSnapshotFailed,
      endpoint: api.analytics.links.url
    });
  }
}

export const getPerformanceSnapshotSaga = takeEvery(types.GET_PERFORMANCE_SNAPSHOT_REQUEST, getPerformanceSnapshot);


